import { Sketches as View } from "ui-components";

import {
	useDeleteSketch,
	useSetActive,
	useSetSelectSketch,
	useSketches,
} from "~map-view/states/sketch";
export const Sketches = (props) => {
	const setActive = useSetActive();
	const sketches = useSketches();
	const setSelectSketch = useSetSelectSketch();
	const deleteSketch = useDeleteSketch();
	const handleCreateSketch = () => {
		setActive?.("Create Sketch");
	};
	const handleEditSketch = (sketch) => {
		setActive?.("edit-sketch");
		setSelectSketch(sketch);
	};
	const handleDeleteSketch = (id) => {
		deleteSketch(id);
	};
	if (props.active === "Sketches")
		return (
			<View
				onDeleteSketch={handleDeleteSketch}
				onEditSketch={handleEditSketch}
				sketches={sketches}
				onCreate={handleCreateSketch}
			/>
		);
	return null;
};
